import { inject, injectable } from 'inversify';
import { IEntitiesAction } from '@Redux/IEntitiesAction';
import { Club, Nullable } from '@Models';
import { TYPES } from '@Types';
import { RequestAction } from '@Repository/RequestAction';
import { ClubRepository, RequestClubsSuccess } from '@Repository/federation';
import clubsSlice from '@Redux/reducers/federation/clubs.slice';
import { PayloadAction } from '@reduxjs/toolkit';

@injectable()
export class ClubsAction extends IEntitiesAction<Club, RequestClubsSuccess> {
  @inject(TYPES.Repository.ClubRepository)
  private _repository!: ClubRepository;

  protected fetchDataSuccess(item: Club[]): PayloadAction<Club[]> {
    return clubsSlice.actions.setClubs(item);
  }

  protected cacheDataSuccess(item: Club[]): PayloadAction<Club[]> {
    return clubsSlice.actions.setClubs(item);
  }

  protected haveError(message: string): PayloadAction<string> {
    return clubsSlice.actions.setError(message);
  }

  protected areLoading(bool: boolean): PayloadAction<boolean> {
    return clubsSlice.actions.setLoading(bool);
  }

  protected async getItems(): Promise<RequestAction> {
    return await this._repository.getAll({ locale: null });
  }

  protected async getCachedItems(): Promise<Nullable<Club[]>> {
    return null;
  }
}
